
  // import(/* webpackChunkName: "vconsole" */ "vconsole").then(Module => {
  //   new Module.default();
  // });

  const Vconsole = require('vconsole')
  // eslint-disable-next-line no-undef
  // new Vconsole({ theme: 'dark' })




// WEBPACK FOOTER //
// ./src/utils/loadVconsoleJs.js